define([
    'componentsCore',
    'lodash',
    'coreUtils'
], function (componentsCore, _, coreUtils) {
    'use strict';

    function createRequest(siteData, svgHash) {
        return coreUtils.svg.createSvgFetchRequest(
            siteData.serviceTopology.mediaRootUrl,
            siteData,
            svgHash);
    }

    function controlsRequirements(siteData, compInfo) {
        const icons = _.get(compInfo, ['design', 'icons']);

        const requests = _.map(icons, function (icon) {
            return createRequest(siteData, icon.svgId);
        });

        return _.compact(requests);
    }


    componentsCore.dataRequirementsCheckerRegistrar.registerCheckerForCompType('wysiwyg.viewer.components.MediaOverlayControls', controlsRequirements);
    componentsCore.dataRequirementsCheckerRegistrar.registerCheckerForCompType('wysiwyg.viewer.components.MediaControls', controlsRequirements);
});


